import { observable, action } from 'mobx'

export default class MyBetsStore {
  defaultFilter = {
    statusSelected: 'OPEN',
    prodTypeSelected: 'ALL',
    daySelected: -1
  }

  @observable productInQuery = [];

  @observable selectedData = this.defaultFilter;

  @action updateData(newData) {
    this.selectedData = newData
  }
  @action updateProductInQuery(newData) {
    this.productInQuery = newData
  }

}



// WEBPACK FOOTER //
// ./src/app/stores/MyBetsStore.js